import { appIcons } from '../content/appIcons';
import type { ProductId } from '../content/products';

const names: Record<ProductId, string> = { veriplus: 'VeriPlus', tambo: 'Tambo', sassy: 'Sassy' };

export function AppIcon({ id, size = 56 }: { id: ProductId; size?: number }) {
  return (
    <span className="app-icon" style={{ width: size, height: size, borderRadius: size * 0.225 }}>
      <img src={appIcons[id]} alt={`${names[id]} app icon`} width={size} height={size} decoding="async" />
    </span>
  );
}

/**
 * The Divergent Networks mark: a hexagon core with five traces diverging from
 * it. Redrawn as a vector from the logo on the cover of the company profile;
 * the outer and centre traces are navy, the inner pair is the signal blue.
 */
export function DivergentMark({ size = 40, inverse = false }: { size?: number; inverse?: boolean }) {
  const navy = inverse ? '#FFFFFF' : 'var(--dn-navy)';
  const blue = 'var(--dn-blue)';
  return (
    <svg
      width={size * 1.1}
      height={size}
      viewBox="0 0 110 100"
      fill="none"
      role="img"
      aria-label="Divergent Networks"
    >
      <path d="M14 37 L25.3 43.5 V56.5 L14 63 L2.7 56.5 V43.5 Z" fill={navy} />
      <g strokeWidth="5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M27 45 L53 19 H70 L77 12" stroke={navy} />
        <path d="M27 55 L53 81 H70 L77 88" stroke={navy} />
        <path d="M31 47 L46 33 H78" stroke={blue} />
        <path d="M31 53 L46 67 H78" stroke={blue} />
        <path d="M28 50 H92" stroke={navy} />
      </g>
      <circle cx="81" cy="8" r="6" fill={navy} />
      <circle cx="81" cy="92" r="6" fill={navy} />
      <circle cx="84" cy="33" r="6" fill={blue} />
      <circle cx="84" cy="67" r="6" fill={blue} />
      <circle cx="98" cy="50" r="6" fill={navy} />
    </svg>
  );
}

export function Logo({ inverse = false }: { inverse?: boolean }) {
  return (
    <span className={`logo${inverse ? ' logo--inverse' : ''}`}>
      <DivergentMark size={34} inverse={inverse} />
      <span className="logo__text">
        <span className="logo__name">Divergent Networks</span>
        <span className="logo__suffix">Limited</span>
      </span>
    </span>
  );
}
